import type { PatchRelease } from "../types";

export const release: PatchRelease = {
  id: "2026-06-03_01",
  version: "2026.06.03",
  date: "3 Jun 2026",
  sinceCommit: "341ee9a",
  gameplay: [
    {
      text: "Spellbook and shop **hover previews**: mouse over any spell to watch it cast in a live arena popover (upgraded same day to run the real Go sim via WASM, not hand-drawn demos).",
    },
    {
      text: "Quick **matchmaking** queue: join matchmaker from the main menu to get grouped into a lobby automatically.",
    },
    {
      text: "Music and sound: UI/combat/shopping-round tracks; server picks the combat song; per-spell cast and impact SFX across the catalog.",
    },
    { text: "Illusion decoys no longer bait bot aim — bots target the real caster even when a decoy is closer." },
  ],
  skills: [
    {
      spellId: "voidrip",
      changes: [{
        text: "Only the inner void core (≈42% of the rip radius) deals damage; the outer crack pulls without draining HP.",
      }],
    },
    {
      spellId: "voidbeam",
      changes: [{
        text: "Max knockback scaling reduced (2.45× → 1.35× at full charge); caster recoil increased; charged beam width capped at 62% of max.",
      }],
    },
    {
      spellId: "illusionist",
      changes: [{
        text: "Decoys now mimic your name and HP at cast time; any hit or the 10s timer ends them (cannot cast).",
      }],
    },
  ],
};
